module.exports = __webpack_public_path__ + "img/base-1.a028e941.png";